import { BREAKPOINTS, MEDIA_QUERIES } from "@constants"
import { generateFluidCalc } from "@utils"
import { BREAK } from "graphql"
import styled, { css, keyframes } from "styled-components"

export enum POST_BOOK_THEMES {
  "ai" = "ai",
  "customer-service" = "customer-service",
  "knowledge-base" = "knowledge-base",
}

export enum POST_BOOK_THEME_STATE {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  ACTIVE_LIGHT = "ACTIVE_LIGHT",
}

const ProgressBarKeyframes = keyframes`
  from { width: 0%; }
  to { width: calc(100% + 8px); }
`

export const PostBookARTICLE = styled.article`
  /* BEGIN THEMES */
  --PostBook--background-rgb: var(--color--basics-white-rgb);
  --PostBook--background: var(--color--basics-white);
  --PostBook--headlines-color: var(--color--text-headline);
  --PostBook--progress-filled: rgba(var(--color--charcoal-1000-rgb), 0.48);
  --PostBook--progress-unfilled: rgba(var(--color--charcoal-400-rgb), 0.48);
  --PostBook--text-color: var(--color--text-default);
  --PostBook--text-dark-color: var(--color--text-dark);
  --PostBook--text-link-color-hovered: var(--color--action-hovered);
  --PostBook--text-link-color: var(--color--action-default);
  --PostBook--SocialShare--background: rgba(var(--color--slate-300-rgb), 0.5);
  --PostBook--SocialShare--background-hovered: rgba(var(--color--slate-300-rgb), 1);
  --PostBook--SocialShare--icon-color: var(--color--charcoal-1200);

  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--background-rgb: var(--color--purple-900-rgb);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--background: var(--color--purple-900);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--headlines-color: var(--color--red-300);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--progress-filled: var(--color--red-300);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--progress-unfilled: rgba(var(--color--red-300-rgb), 0.48);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-color: rgba(var(--color--red-300-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-dark-color: rgba(var(--color--red-300-rgb), 0.9);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-link-color-hovered: rgba(var(--color--red-400-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-link-color: rgba(var(--color--red-500-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--background: rgba(var(--color--red-300-rgb), 0.48);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--background-hovered: rgba(var(--color--red-300-rgb), 1);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--icon-color: var(--color--purple-900);

  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--background-rgb: var(--color--red-200-rgb);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--background: var(--color--red-200);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--headlines-color: var(--color--purple-900);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--progress-filled: var(--color--purple-900);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--progress-unfilled: rgba(var(--color--purple-900-rgb), 0.08);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-color: rgba(var(--color--purple-900-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-dark-color: rgba(var(--color--purple-900-rgb), 0.9);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-link-color-hovered: rgba(var(--color--red-600-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-link-color: rgba(var(--color--red-700-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--background: rgba(var(--color--red-400-rgb), 0.5);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--background-hovered: rgba(var(--color--red-400-rgb), 1);
  --PostBook--${POST_BOOK_THEMES["ai"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--icon-color: var(--color--purple-900);

  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--background-rgb: var(--color--cobalt-900-rgb);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--background: var(--color--cobalt-900);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--headlines-color: var(--color--purple-300);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--progress-filled: var(--color--purple-300);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--progress-unfilled: rgba(var(--color--cobalt-300-rgb), 0.48);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-color: rgba(var(--color--purple-300-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-dark-color: rgba(var(--color--purple-300-rgb), 0.9);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-link-color-hovered: rgba(var(--color--purple-400-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-link-color: rgba(var(--color--purple-500-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--background: rgba(var(--color--purple-300-rgb), 0.48);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--background-hovered: rgba(var(--color--purple-300-rgb), 1);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--icon-color: var(--color--cobalt-900);

  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--background-rgb: var(--color--purple-200-rgb);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--background: var(--color--purple-200);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--headlines-color: var(--color--cobalt-900);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--progress-filled: var(--color--cobalt-900);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--progress-unfilled: rgba(var(--color--cobalt-900-rgb), 0.08);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-color: rgba(var(--color--cobalt-900-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-dark-color: rgba(var(--color--cobalt-900-rgb), 0.9);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-link-color-hovered: rgba(var(--color--purple-600-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-link-color: rgba(var(--color--purple-700-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--background: rgba(var(--color--purple-400-rgb), 0.5);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--background-hovered: rgba(var(--color--purple-400-rgb), 1);
  --PostBook--${POST_BOOK_THEMES["customer-service"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--icon-color: var(--color--cobalt-900);

  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--background-rgb: var(--color--slate-900-rgb);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--background: var(--color--slate-900);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--headlines-color: var(--color--green-300);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--progress-filled: var(--color--green-300);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--progress-unfilled: rgba(var(--color--green-300-rgb), 0.48);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-color: rgba(var(--color--green-300-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-dark-color: rgba(var(--color--green-300-rgb), 0.9);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-link-color-hovered: rgba(var(--color--green-400-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--text-link-color: rgba(var(--color--green-500-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--background: rgba(var(--color--green-300-rgb), 0.48);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--background-hovered: rgba(var(--color--green-300-rgb), 1);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE}--SocialShare--icon-color: var(--color--slate-900);

  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--background-rgb: var(--color--green-200-rgb);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--background: var(--color--green-200);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--headlines-color: var(--color--slate-900);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--progress-filled: var(--color--slate-900);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--progress-unfilled: rgba(var(--color--slate-900-rgb), 0.08);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-color: rgba(var(--color--slate-900-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-dark-color: rgba(var(--color--slate-900-rgb), 0.9);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-link-color-hovered: rgba(var(--color--green-600-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--text-link-color: rgba(var(--color--green-700-rgb), 0.8);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--background: rgba(var(--color--green-400-rgb), 0.5);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--background-hovered: rgba(var(--color--green-400-rgb), 1);
  --PostBook--${POST_BOOK_THEMES["knowledge-base"]}--${POST_BOOK_THEME_STATE.ACTIVE_LIGHT}--SocialShare--icon-color: var(--color--slate-900);

  ${Object.keys(POST_BOOK_THEMES).map(themeName => [POST_BOOK_THEME_STATE.ACTIVE, POST_BOOK_THEME_STATE.ACTIVE_LIGHT].map(themeState => css`
    &.theme--${themeName} .theme-state--${themeState} {
      --PostBook--background-rgb: var(--PostBook--${themeName}--${themeState}--background-rgb);
      --PostBook--background: var(--PostBook--${themeName}--${themeState}--background);
      --PostBook--headlines-color: var(--PostBook--${themeName}--${themeState}--headlines-color);
      --PostBook--progress-filled: var(--PostBook--${themeName}--${themeState}--progress-filled);
      --PostBook--progress-unfilled: var(--PostBook--${themeName}--${themeState}--progress-unfilled);
      --PostBook--text-color: var(--PostBook--${themeName}--${themeState}--text-color);
      --PostBook--text-dark-color: var(--PostBook--${themeName}--${themeState}--text-dark-color);
      --PostBook--text-link-color-hovered: var(--PostBook--${themeName}--${themeState}--text-link-color-hovered);
      --PostBook--text-link-color: var(--PostBook--${themeName}--${themeState}--text-link-color);
      --PostBook--SocialShare--background: var(--PostBook--${themeName}--${themeState}--SocialShare--background);
      --PostBook--SocialShare--background-hovered: var(--PostBook--${themeName}--${themeState}--SocialShare--background-hovered);
      --PostBook--SocialShare--icon-color: var(--PostBook--${themeName}--${themeState}--SocialShare--icon-color);

      .Content {
        --Content--headlines-color: var(--PostBook--headlines-color);
        --Content--link-color-hovered: var(--PostBook--text-link-color-hovered);
        --Content--link-color: var(--PostBook--text-link-color); 
        --Content--text-color: var(--PostBook--text-color);
        --Content--text-dark-color: var(--PostBook--text-dark-color);
      }

      /* BEGIN component styles */
      background-color: var(--PostBook--background);
    }
  `)).flat()}

  /* BEGIN Child variables */
  --PostBook--progress-bar-height: 8px;
  --PostBookHero--image-max-width: var(--max-width--column--10);
  --PostBookHero--image-max-height: 60vh;
  --PostBookHero--padding-top: min(
    calc(
      min(
        100vw,
        var(--PostBookHero--image-max-width)
      ) / 16 * 9 * 0.8
    ),
    calc(var(--PostBookHero--image-max-height) * 0.8)
  );
  --PostBookSocialShare--column-width: calc(36px + var(--spacing--L));

  --PostBookNav--max-width: 284px;

  ${MEDIA_QUERIES.L} {
    --PostBookNav--max-width: ${generateFluidCalc(284, 480, BREAKPOINTS.L, BREAKPOINTS["2XL"])};
  }
  /* END Child variables */

  margin-top: var(--SiteNav--height);

  .SubNav {
    margin: 0;
  }

  .progress-bar {
    background-color: var(--PostBook--progress-unfilled);
    height: var(--PostBook--progress-bar-height);
    margin-bottom: calc(var(--PostBook--progress-bar-height) * -1);
    overflow: hidden;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 3;

    &--indicator {
      animation: ${ProgressBarKeyframes} linear both;
      animation-timeline: scroll(root);
      animation-range: 0% calc(100% - 50vh);
      height: var(--PostBook--progress-bar-height);
      background: var(--PostBook--progress-filled);
      border-radius: 0 4px 4px 0;
    }
  }

  .PostBook--nav-toggle-wrapper {
    --PostBook--nav-toggle-wrapper-height: calc(var(--spacing--M) * 2 + var(--PostBook--progress-bar-height));

    align-items: flex-end;
    display: flex;
    height: var(--PostBook--nav-toggle-wrapper-height);
    margin: 0 auto calc(var(--PostBook--nav-toggle-wrapper-height) * -1);
    max-width: var(--container-width);
    position: sticky;
    top: 0;
    width: var(--container-width);
    z-index: 1;
    
    ${MEDIA_QUERIES.L} {
      display: none;
    }
  }
`

export const PostBookDIV = styled.div`
  display: grid;

  .PostBookHero {
    grid-area: 1/1/2/2;
  }

  .SocialShare--wrapper {
    grid-area: 1/1/3/2;
  }

  .PostContent > div {
    margin-bottom: var(--spacing--M);
    max-width: min(var(--container-width), var(--text-max-width));
    width: 100%;
  }

  .PostBookNav:not(.is-static) {
    flex: 0 0 var(--PostBookNav--max-width);
  }

  .SocialShare--wrapper {
    .SocialShare {
      z-index: 2;
      
      li a {
        background: var(--PostBook--SocialShare--background);

        .Icon {
          background: var(--PostBook--SocialShare--icon-color);
        }

        &:hover {
          background: var(--PostBook--SocialShare--background-hovered);
        }
      }
    }
  }

  .PostBook--content {
    display: flex;
    grid-area: 2/1/3/2;
    transition: translate 0.3s;
    translate: calc(var(--PostBookNav--max-width) * -1);

    .is-nav-open & {
      translate: 0;
    }
  }

  .PostBook--content-main {
    flex: 0 0 100%;
    max-width: 100%;
  }

  ${MEDIA_QUERIES.L} {
    .SocialShare--wrapper {
      display: block;
      padding-top: var(--PostBookHero--padding-top);

      .SocialShare {
        display: block;
        float: right;
        margin: 0 var(--spacing--S) 0 0;
        top: calc(var(--spacing--M) + var(--PostBook--progress-bar-height));
        padding-bottom: var(--spacing--XL);
        z-index: 1;

        li:last-child {
          margin-bottom: 0;
        }
      }
    }

    .PostBook--content {
      translate: 0;
    }

    .PostBookNav:not(.is-static) {
      margin: 0;
      padding-right: var(--spacing--M);
    }

    .PostBook--content-main {
      flex: 0 0 calc(100% - var(--PostBookNav--max-width));
      padding:
        var(--spacing--L)
        calc(var(--spacing--M) + var(--spacing--S) * 2)
        0
        0;
    }

    // .Content Overrides
    .PostContent {
      --container-width: 100%;

      .container {
        max-width: 100%;
      }
      
      .ContentBreakout {
        margin: 0 calc((100vw - var(--PostBookNav--max-width) - var(--spacing--XL)) / -2 + 100% / 2);
      }

      // Fix for CtaBlock width
      .Cta {
        .column--2-12-L {
          grid-column: 1 / 13;
        }
      }
    }
  }

  ${MEDIA_QUERIES.XL} {
    .SocialShare--wrapper .SocialShare {
      margin-right: var(--spacing--L);
    }

    .PostContent {
      --container-width: min(calc(100vw - var(--spacing--M) * 2), 1280px);

      .ContentBreakout {
        margin: 0 calc((50vw - min(var(--container-width), var(--text-max-width)) / 2) * -1);
        padding: 0 var(--PostBookNav--max-width);
      }

      .Cta {
        .column--3-11-XL {
          grid-column: 3 / 11;
        }
      }
    }

    .PostBook--content-main {
      padding-right: var(--PostBookNav--max-width);
    }
  }
`
